<template>
	<section class="row">
		<base-card class="card" mode="shadow">
			<h2>💀 Page not found 💀</h2>
			<img src="https://i.gifer.com/yH.gif" alt="travolta" />
		</base-card>
	</section>
</template>

<style scoped>
section {
	margin-top: 3.2rem;
}
img {
	display: block;
	padding: 0;
	width: 100%;
}

h2 {
	margin-bottom: 1em;
	text-align: center;
	font-family: var(--font-display);
	font-weight: normal;
}
</style>